module.exports = __webpack_public_path__ + "79878fb469406f4e225bdfb6f85e24fe.gif";